import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItemText, ListSubheader } from '../../material-ui/List';
import { CrewTypes } from '../../../service/constants';
import { ContentType } from './constants';
import { useAdditionalInfoContent } from './useAdditionalInfoContent';
import { useStyles } from './useStyles';

export const AdditionalInfoContent = memo(() => {
    const { Component, contentType, crewType, currentLegInfo, plnName, title } = useAdditionalInfoContent();
    const { t: translate } = useTranslation();
    const classes = useStyles();

    return (
        <List className="menu-list" component="div" disablePadding={true}>
            {crewType === CrewTypes.PCT_CABINSTAFF || crewType === CrewTypes.PCT_SALONSTAFF ? (
                <>
                    <ListSubheader classes={{ root: classes.listSubheader }}>
                        <ListItemText
                            primary={
                                <>
                                    {translate(title)} {currentLegInfo}
                                    {contentType === ContentType.LIMITATIONS && (
                                        <span className={classes.bold}>{(plnName && ` ${plnName.toUpperCase()}`) || ''}</span>
                                    )}
                                </>
                            }
                        />
                    </ListSubheader>
                    {Component && <Component />}
                </>
            ) : (
                <ListItemText primary={translate('messages.noAvailableInfoForLeg')} />
            )}
        </List>
    );
});

AdditionalInfoContent.displayName = 'AdditionalInfoContent';
